import React from 'react';
import { SiteHeader, SiteFooter } from './Layout';
import './App.css';

function PrivacyPolicy() {
  return (
    <div className="page">
      <SiteHeader />

      <main className="legal container">
        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-date">Last updated: August 28, 2025</p>

        <div className="policy-section">
          <h2>1. Information We Collect</h2>
          <p>
            Code That Down LLC ("we," "our," or "us") collects information you provide directly to us, 
            such as when you contact us through our website, request information about our services, 
            or communicate with us via email or social media.
          </p>
          <p>Types of information we may collect include:</p>
          <ul>
            <li>Name and contact information (email address, phone number)</li>
            <li>Company or organization information</li>
            <li>Project requirements and specifications</li>
            <li>Communication preferences</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Respond to your inquiries and provide customer support</li>
            <li>Communicate with you about our services</li>
            <li>Develop and deliver custom software solutions</li>
            <li>Improve our services and website functionality</li>
            <li>Comply with legal obligations</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Information Sharing and Disclosure</h2>
          <p>
            We do not sell, trade, or otherwise transfer your personal information to third parties 
            without your consent, except as described in this policy. We may share your information:
          </p>
          <ul>
            <li>With service providers who assist us in operating our business</li>
            <li>When required by law or to protect our rights</li>
            <li>In connection with a business transfer or acquisition</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal 
            information against unauthorized access, alteration, disclosure, or destruction. However, 
            no method of transmission over the internet or electronic storage is 100% secure.
          </p>
        </div>

        <div className="policy-section">
          <h2>5. Data Retention</h2>
          <p>
            We retain your personal information only for as long as necessary to fulfill the purposes 
            for which it was collected, comply with legal obligations, resolve disputes, and enforce 
            our agreements.
          </p>
        </div>

        <div className="policy-section">
          <h2>6. Your Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access and receive a copy of your personal information</li>
            <li>Rectify inaccurate personal information</li>
            <li>Request deletion of your personal information</li>
            <li>Object to or restrict processing of your personal information</li>
            <li>Data portability</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>7. Cookies and Tracking Technologies</h2>
          <p>
            Our website may use cookies and similar tracking technologies to enhance your browsing 
            experience, analyze website traffic, and understand user preferences. You can control 
            cookie settings through your browser preferences.
          </p>
        </div>

        <div className="policy-section">
          <h2>8. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not responsible for the 
            privacy practices or content of these external sites. We encourage you to review the 
            privacy policies of any third-party sites you visit.
          </p>
        </div>

        <div className="policy-section">
          <h2>9. Children's Privacy</h2>
          <p>
            Our services are not directed to children under the age of 13. We do not knowingly 
            collect personal information from children under 13. If we become aware that we have 
            collected such information, we will take steps to delete it promptly.
          </p>
        </div>

        <div className="policy-section">
          <h2>10. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any material 
            changes by posting the new Privacy Policy on this page and updating the "Last updated" 
            date at the top of this policy.
          </p>
        </div>

        <div className="policy-section">
          <h2>11. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or our privacy practices, 
            please contact us at:
          </p>
          <div className="contact-info">
            <p><strong>Code That Down LLC</strong></p>
            <p>Email: <a href="mailto:contact@codethatdown.com">contact@codethatdown.com</a></p>
            <p>LinkedIn: <a href="https://www.linkedin.com/company/code-that-down" target="_blank" rel="noopener noreferrer">Code That Down</a></p>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}

export default PrivacyPolicy;
